import React from "react";
import PropTypes from "prop-types";
const HashCrossedIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 16}
    height={height || size || 16}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
  >
    <title>{title}</title>
    <g fill="none" fillRule="evenodd">
      <path d="M-156-27H89V90h-245z" />
      <path
        d="M2.613 1.21l.094.083 16 16a1 1 0 01-1.32 1.497l-.094-.083L15 16.415V17a1 1 0 01-2 0v-2H7v2a1 1 0 01-2 0v-2H3a1 1 0 010-2h2V7H3a1 1 0 110-2h.585L1.293 2.707a1 1 0 011.32-1.497zM7 8.415V13h4.585L7 8.415zM14 2a1 1 0 011 1v2h2a1 1 0 010 2h-2v3l-2-2V7h-1l-2-2h3V3a1 1 0 011-1z"
        fill={color || "var(--color-easil-gray-x-dark)"}
      />
    </g>
  </svg>
);
HashCrossedIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default HashCrossedIcon;
